import React, { useState, useEffect } from 'react';
import Storage from '@aws-amplify/storage';

const S3Image = ({ s3_key, className, ...imgProps }) => {
  const [src, setSrc] = useState('');

  useEffect(() => {
    if (s3_key)
      Storage.get(s3_key)
        .then((url) => setSrc(url.toString()))
        .catch((err) => console.warn(err));
  }, [s3_key]);

  if (!src)
    return (
      <div className={className}>
        <div className="flex flex-col items-center justify-center w-full h-full">
          <div className="w-8 h-8 spinner bg-jcap-200" />
        </div>
      </div>
    );

  return (
    <div className={className}>
      <img className="w-full h-full" {...imgProps} src={src} alt="" />
    </div>
  );
};

export default S3Image;
